export const routes = {
  login: "/login",
  unauthorized: "/unauthorized"
};
